import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['body', 'button']> = defineContent({
	default: {
		body: {
			id: 'jira-sidebar-nav-day-x-notification.body-text',
			defaultMessage:
				'We’ve added features to boost your productivity. <strong>Customize your sidebar</strong> to change what shows up.',
			description: 'Jira Sidebar Reintroduce Nav Items body text',
			role: 'title',
		},
		button: {
			id: 'jira-sidebar-nav-day-x-notification.button-text',
			defaultMessage: 'Got it',
			description: 'Jira Sidebar Reintroduce Nav Items button text',
			role: 'description',
		},
	},
});
